/* eslint-disable @typescript-eslint/no-explicit-any */
// ==============================
// Types
// ==============================
export enum ClassStatus {
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  CANCELLED = 'CANCELLED',
}

export interface Response<T> {
  data: T[];
}

export interface PaginatedResponse<T> {
  data: T[];
  metadata: {
    totalItems: number;
    currentPage: number;
    totalPages: number;
    limit: number;
  };
}

export type SuccessResponse = {
  status: number;
  message: string;
  data: any;
  metadata?: any;
};

export type ServiceType = {
  id: string;
  name: string;
  subtypes: Subtype[];
};

export interface Subsubtype {
  id: number;
  name: string;
  serviceFor: string;
  unitMeasure?: string;
  duration: number;
  visitType: string;
  visitBalance: number;
}
export interface Subtype {
  id: number;
  name: string;
  subsubtypes?: Subsubtype[];
}

export interface Class {
  id: number;
  name: string;
  // startDate: string;
  // endDate: string;
  classDate?: string;
  startTime?: string;
  endTime?: string;
  // duration: number;
  // dates?: string[];
  level?: string;
  maxStudents: number;
  studentCount: number;
  subtype: Subtype;
  subtypeName: string;
  status: ClassStatus;
  coachTeachers?: string[];
  note?: string;
  createdAt: string;
  updateAt: string;
  deletionMark: boolean;
}

export interface Coach {
  id: number;
  email: string;
  name: string | null;
  createdAt: string;
  updateAt: string;
  deletionMark: boolean;
}

export interface ClassCoach {
  id: number;
  classId: number;
  class: Class;
  coachId: number;
  coach: Coach;
  createdAt: string;
  updateAt: string;
  deletionMark: boolean;
}

export type Gender = 'MALE' | 'FEMALE' | 'UNDEFINED';

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  preferredName?: string | null;
  businessName?: string | null;
  email?: string | null;
  phone?: string | null;
  parent?: string | null;
  dob: string; // ISO date string
  gender?: Gender;
  address?: string | null;
  idCard?: string | null;
  taxCode?: string | null;
  userType: 'ADULT' | 'CHILD' | 'GROUP' | 'BUSINESS';
  pictureUrl: string; // URL to the user's picture
  createdAt: string; // ISO date string
  updateAt: string; // ISO date string
  deletionMark: boolean;
}

export interface SubSubType {
  id: number;
  name: string;
  invoiceName: string | null;
  invoiceNameForChild: string | null;
  serviceFor: string;
  price: number;
  priceForChild?: number;
  vatRate: number;
  unitMeasure?: string;
  duration: number;
  visitType: string;
  visitBalance: number;
}

export interface Registration {
  id: number;
  userId: number;
  user: User;
  subsubtypeId: number;
  subsubtype: SubSubType;
  subtype: string;
  serviceType: string;
  joined?: boolean; // Optional, as it may not be applicable for all registrations
  courseLevel?: string; // Optional, as it may not be applicable for all registrations
  sos?: string;
  eos?: string;
  createdAt: string; // ISO date string
  updateAt: string; // ISO date string
  deletionMark: boolean;
  packages?: ClassStudentPackage[];
}

export interface ClassStudentPackage {
  id: number;
  course: string;
  registrationStartDate: string;
  registrationEndDate: string;
}

export interface ClassStudent {
  id: number;
  classId: number;
  userId: number;
  class: Class;
  registrationId: number;
  registration: Registration;
  createdAt: string;
  updateAt: string;
  deletionMark: boolean;
}

export interface CourseLevel {
  level: number;
  levelName: string;
}

export interface CheckInSummary {
  totalStudents: number;
  totalCheckedInStudents: number;
  summary: {
    id: number;
    studentInfo: Registration;
    isCheckInToday: boolean;
  }[];
}
